module.exports = __webpack_public_path__ + "static/assets/5f031e293683fa012a170dd281b0daf6.svg";